(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (typeof Shopify === 'undefined' || !Shopify.analytics) return;

  // ---- Standard GA4 ecommerce dataLayer push (main page context) ----
  // GTM triggers (TikTok etc.) read window.dataLayer on the main page.
  // ga4.js runs in a sandboxed Web Pixel iframe whose dataLayer is invisible to GTM,
  // so we push here instead, where we already have the data assembled.
  function dlPush(eventName, ecommerceObj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // clear previous ecommerce context
    window.dataLayer.push({ event: eventName, ecommerce: ecommerceObj });
  }

  // ---- Per-product list info helpers ----
  // Her ürün için hangi listeden geldiğini sessionStorage'da sakla
  // Böylece cart/checkout adımlarında doğru list bilgisi korunur
  function saveProductListInfo(itemId, listId, listName, index) {
    if (!itemId) return;
    try {
      var stored = JSON.parse(sessionStorage.getItem('gtm_product_lists') || '{}');
      stored[itemId] = { listId: listId || '', listName: listName || '', index: index || 0 };
      sessionStorage.setItem('gtm_product_lists', JSON.stringify(stored));
      // Backward compat — son tıklanan ürünün bilgisini tek değer olarak da sakla
      sessionStorage.setItem('gtm_item_list_id', listId || '');
      sessionStorage.setItem('gtm_item_list_name', listName || '');
      sessionStorage.setItem('gtm_item_index', index || 0);
    } catch (e) {}
  }

  function getProductListInfo(itemId) {
    var fallback = { listId: '', listName: '', index: 0 };
    try {
      if (itemId) {
        var stored = JSON.parse(sessionStorage.getItem('gtm_product_lists') || '{}');
        if (stored[itemId]) return stored[itemId];
      }
      // Fallback: tek değer storage
      fallback.listId = sessionStorage.getItem('gtm_item_list_id') || '';
      fallback.listName = sessionStorage.getItem('gtm_item_list_name') || '';
      fallback.index = parseInt(sessionStorage.getItem('gtm_item_index'), 10) || 0;
    } catch (e) {}
    return fallback;
  }

  // Metafield-based category/variant → native localStorage (key 'ga4_item_meta', shape {itemId:{c,c2,v}}).
  // Checkout cannot see product metafields, so the Custom Pixel (ga4.js) reads this key on checkout
  // events. Pixel storage (browser.localStorage) is async and runs in the top frame, which on this
  // store is the same origin as the storefront, so it reads this same localStorage.
  // Deliberately NOT cart line item properties: the order service breaks on them (PR #166/#174).
  var ITEM_META_KEY = 'ga4_item_meta';
  var ITEM_META_MAX = 300;
  function saveItemMetaToStorage(itemId, category, category2, variant) {
    if (!itemId || (!category && !category2 && !variant)) return;
    try {
      var stored = {};
      try {
        var raw = localStorage.getItem(ITEM_META_KEY);
        stored = raw ? JSON.parse(raw) : {};
      } catch (parseError) { stored = {}; } // corrupt value: start over instead of failing forever
      if (!stored || typeof stored !== 'object') stored = {};
      var id = String(itemId);
      delete stored[id]; // re-insert so the most recently used items stay at the end
      stored[id] = { c: category || '', c2: category2 || '', v: variant || '' };
      var ids = Object.keys(stored);
      if (ids.length > ITEM_META_MAX) {
        ids.slice(0, ids.length - ITEM_META_MAX).forEach(function(k) { delete stored[k]; });
      }
      localStorage.setItem(ITEM_META_KEY, JSON.stringify(stored));
    } catch (e) {}
  }

  function getListInfo(el) {
    var section = el.closest('[data-section-id]');

    // 1. Tab sistemi varsa aktif tabs__panel'dan oku
    if (section && section.getAttribute('data-has-tabs')) {
      var panel = el.closest('.tabs__panel');
      if (panel) {
        return {
          id: panel.getAttribute('data-list-id') || '',
          name: panel.getAttribute('data-list-name') || ''
        };
      }
    }

    // 2. ProductsList varsa oradan oku
    var productsList = document.getElementById('ProductsList');
    if (productsList) {
      return {
        id: productsList.getAttribute('data-list-id') || '',
        name: productsList.getAttribute('data-list-name') || ''
      };
    }

    // 3. Tab yoksa section başlığından oku, yoksa data-list-name attribute'undan
    if (section) {
      var heading = section.querySelector('h1, h2, h3');
      var headingText = heading ? heading.innerText.trim() : '';
      var listName = headingText || section.getAttribute('data-list-name') || '';
      var listId = section.getAttribute('data-list-id') || '';
      return { id: listId, name: listName };
    }

    return { id: '', name: '' };
  }

  // VIEW ITEM LIST - Collection ve liste sayfaları için
  function sendViewItemListEvent() {
    // Tüm section'ları bul (featured-collection, tabs__panel vb.)
    var sections = document.querySelectorAll('[data-section-id]');
    var processedListIds = {};

    sections.forEach(function(section) {
      var hasTabs = section.getAttribute('data-has-tabs') === 'true';

      if (hasTabs) {
        // Tab olan section'larda sadece ilk (aktif) panel için event gönder
        var firstPanel = section.querySelector('.tabs__panel');
        if (firstPanel) {
          sendViewItemListForSection(firstPanel, processedListIds);
        }
      } else {
        // Tab olmayan section'larda doğrudan section için event gönder
        sendViewItemListForSection(section, processedListIds);
      }
    });

    // Section dışında kalan ProductsList için de kontrol et
    var productsList = document.getElementById('ProductsList');
    if (productsList) {
      var listId = productsList.getAttribute('data-list-id') || '';
      if (listId && !processedListIds[listId]) {
        sendViewItemListForSection(productsList, processedListIds);
      }
    }
  }

  function sendViewItemListForSection(container, processedListIds) {
    var productCards = container.querySelectorAll('[data-item-handle]');
    if (productCards.length === 0) return;

    var firstCard = productCards[0];

    // List bilgisini card'dan veya getListInfo'dan al
    var listId = firstCard.getAttribute('data-list-id') || '';
    var listName = firstCard.getAttribute('data-list-name') || '';

    // Eğer card'da yoksa getListInfo'dan al
    if (!listId && !listName) {
      var list = getListInfo(firstCard);
      listId = list.id;
      listName = list.name;
    }

    if (!listId && !listName) return;

    // Aynı listId için tekrar event gönderme
    var listKey = listId || listName;
    if (processedListIds[listKey]) return;
    processedListIds[listKey] = true;

    var items = [];
    productCards.forEach(function(card) {
      var priceValue = card.getAttribute('data-item-price');
      var discountValue = card.getAttribute('data-item-discount');

      var price = priceValue ? parseFloat(priceValue) : 0;
      var discount = discountValue ? parseFloat(discountValue) : 0;

      items.push({
        item_id: card.getAttribute('data-item-id') || '',
        item_name: card.getAttribute('data-item-name') || '',
        item_brand: card.getAttribute('data-item-brand') || '',
        item_category: card.getAttribute('data-item-category') || '',
        item_category2: card.getAttribute('data-item-category2') || '',
        item_variant: card.getAttribute('data-item-variant') || '',
        item_list_id: listId,
        item_list_name: listName,
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        quantity: 1,
        index: parseInt(card.getAttribute('data-item-index'), 10) || 0
      });
    });

    if (items.length > 0) {
      dlPush('view_item_list', { currency: 'TRY', item_list_id: listId, item_list_name: listName, items: items });
      Shopify.analytics.publish('custom_view_item_list', {
        item_list_id: listId,
        item_list_name: listName,
        items: items
      });
    }
  }

  // SELECT ITEM - Ürün tıklandığında
  document.addEventListener('click', function (e) {
    //e.preventDefault();
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;

    var card = link.closest('[data-item-handle]');
    if (!card) return;

    // List bilgisini card'dan veya getListInfo'dan al
    var listId = card.getAttribute('data-list-id') || '';
    var listName = card.getAttribute('data-list-name') || '';

    // Eğer card'da yoksa getListInfo'dan al
    if (!listId && !listName) {
      var list = getListInfo(card);
      listId = list.id;
      listName = list.name;
    }

    if (!listId && !listName) return;

    var priceValue = card.getAttribute('data-item-price');
    var discountValue = card.getAttribute('data-item-discount');

    var price = priceValue ? parseFloat(priceValue) : 0;
    var discount = discountValue ? parseFloat(discountValue) : 0;

    // Per-product list bilgisini kaydet
    var itemId = card.getAttribute('data-item-id') || '';
    var itemIndex = parseInt(card.getAttribute('data-item-index'), 10) || 0;
    if (listId || listName) {
      saveProductListInfo(itemId, listId, listName, itemIndex);
    }
    saveItemMetaToStorage(itemId, card.getAttribute('data-item-category'), card.getAttribute('data-item-category2'), card.getAttribute('data-item-variant'));

    var selectItem = {
      item_id: card.getAttribute('data-item-id') || '',
      item_name: card.getAttribute('data-item-name') || '',
      item_brand: card.getAttribute('data-item-brand') || '',
      item_category: card.getAttribute('data-item-category') || '',
      item_category2: card.getAttribute('data-item-category2') || '',
      item_variant: card.getAttribute('data-item-variant') || '',
      item_list_id: listId,
      item_list_name: listName,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: parseInt(card.getAttribute('data-item-index'), 10) || 0,
      quantity: 1
    };
    dlPush('select_item', { item_list_id: listId, item_list_name: listName, items: [selectItem] });
    Shopify.analytics.publish('select_item', {
      item_list_id: listId,
      item_list_name: listName,
      item_id: selectItem.item_id,
      item_name: selectItem.item_name,
      item_brand: selectItem.item_brand,
      item_category: selectItem.item_category,
      item_category2: selectItem.item_category2,
      item_variant: selectItem.item_variant,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: selectItem.index
    });
  });

  // Tab section wrapper'ları için event listener ekle
  function initTabListeners() {
    var tabSections = document.querySelectorAll('[data-has-tabs]');
    tabSections.forEach(function(wrapper) {
      wrapper.addEventListener('tabChange', function(e) {
        // Tab değiştiğinde sadece o section içindeki ürünler için event tetikle
        setTimeout(function() {
          // Aktif panel'i bul (hidden attribute olmayan)
          var panels = wrapper.querySelectorAll('.tabs__panel');
          var activePanel = null;

          panels.forEach(function(panel) {
            if (!panel.hidden) {
              activePanel = panel;
            }
          });

          if (!activePanel) return;

          var productCards = activePanel.querySelectorAll('[data-item-handle]');
          if (productCards.length === 0) return;

          var firstCard = productCards[0];
          var listId = firstCard.getAttribute('data-list-id') || '';
          var listName = firstCard.getAttribute('data-list-name') || '';

          if (!listId && !listName) {
            var list = getListInfo(firstCard);
            listId = list.id;
            listName = list.name;
          }

          if (!listId && !listName) return;

          var items = [];
          productCards.forEach(function(card) {
            var priceValue = card.getAttribute('data-item-price');
            var discountValue = card.getAttribute('data-item-discount');

            var price = priceValue ? parseFloat(priceValue) : 0;
            var discount = discountValue ? parseFloat(discountValue) : 0;

            items.push({
              item_id: card.getAttribute('data-item-id') || '',
              item_name: card.getAttribute('data-item-name') || '',
              item_brand: card.getAttribute('data-item-brand') || '',
              item_category: card.getAttribute('data-item-category') || '',
              item_category2: card.getAttribute('data-item-category2') || '',
              item_variant: card.getAttribute('data-item-variant') || '',
              item_list_id: listId,
              item_list_name: listName,
              price: price.toFixed(2),
              discount: discount.toFixed(2),
              quantity: 1,
              index: parseInt(card.getAttribute('data-item-index'), 10) || 0
            });
          });

          if (items.length > 0) {
            dlPush('view_item_list', { currency: 'TRY', item_list_id: listId, item_list_name: listName, items: items });
            Shopify.analytics.publish('custom_view_item_list', {
              item_list_id: listId,
              item_list_name: listName,
              items: items
            });
          }
        }, 100);
      });
    });
  }

  // Sayfa yüklendiğinde view_item_list event'ini tetikle
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      sendViewItemListEvent();
      initTabListeners();
    });
  } else {
    sendViewItemListEvent();
    initTabListeners();
  }

  // Facet/pagination değişikliklerinde yeniden tetikle
  document.addEventListener('facet:updated', sendViewItemListEvent);

  // Product Recommendations için MutationObserver
  // Bu section dinamik olarak yüklendiği için özel izleme gerekiyor
  function initProductRecommendations() {
    var containers = document.querySelectorAll('product-recommendations');

    containers.forEach(function(container) {
      // İçerik zaten yüklenmişse hemen event gönder
      var cards = container.querySelectorAll('[data-item-handle]');
      if (cards.length > 0) {
        sendViewItemListForContainer(cards);
        return;
      }

      // İçerik henüz yüklenmediyse MutationObserver ile bekle
      var observer = new MutationObserver(function(mutations, obs) {
        var cards = container.querySelectorAll('[data-item-handle]');
        if (cards.length > 0) {
          sendViewItemListForContainer(cards);
          obs.disconnect();
        }
      });

      observer.observe(container, { childList: true, subtree: true });
    });
  }

  function sendViewItemListForContainer(cards) {
    if (cards.length === 0) return;

    var firstCard = cards[0];
    var listId = firstCard.getAttribute('data-list-id') || '';
    var listName = firstCard.getAttribute('data-list-name') || '';

    if (!listId && !listName) {
      var list = getListInfo(firstCard);
      listId = list.id;
      listName = list.name;
    }

    if (!listId && !listName) return;

    var items = [];
    cards.forEach(function(card) {
      var priceValue = card.getAttribute('data-item-price');
      var discountValue = card.getAttribute('data-item-discount');

      var price = priceValue ? parseFloat(priceValue) : 0;
      var discount = discountValue ? parseFloat(discountValue) : 0;

      items.push({
        item_id: card.getAttribute('data-item-id') || '',
        item_name: card.getAttribute('data-item-name') || '',
        item_brand: card.getAttribute('data-item-brand') || '',
        item_category: card.getAttribute('data-item-category') || '',
        item_category2: card.getAttribute('data-item-category2') || '',
        item_variant: card.getAttribute('data-item-variant') || '',
        item_list_id: listId,
        item_list_name: listName,
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        quantity: 1,
        index: parseInt(card.getAttribute('data-item-index'), 10) || 0
      });
    });

    if (items.length > 0) {
      dlPush('view_item_list', { currency: 'TRY', item_list_id: listId, item_list_name: listName, items: items });
      Shopify.analytics.publish('custom_view_item_list', {
        item_list_id: listId,
        item_list_name: listName,
        items: items
      });
    }
  }

  // Product recommendations için init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRecommendations);
  } else {
    initProductRecommendations();
  }

  // ADD TO CART - Ürün sepete eklendiğinde (btn--add-to-cart butonu ile)
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.btn--add-to-cart');
    if (!button) return;

    var card = button.closest('[data-item-handle]');
    if (!card) return;

    // PDP'deki add-to-cart butonu bu handler'a girmesin — PDP'yi product-ajax:added handler'ı yakalar
    if (card.classList.contains('product-form')) return;

    // List bilgisini card'dan veya getListInfo'dan al
    var listId = card.getAttribute('data-list-id') || '';
    var listName = card.getAttribute('data-list-name') || '';

    // Eğer card'da yoksa getListInfo'dan al
    if (!listId && !listName) {
      var list = getListInfo(card);
      listId = list.id;
      listName = list.name;
    }

    var itemId = card.getAttribute('data-item-id') || '';
    var itemIndex = parseInt(card.getAttribute('data-item-index'), 10) || 0;

    // product-ajax:added (AJAX tamamlandığında) buradan okunan list bilgisiyle publish eder
    if (listId || listName) {
      saveProductListInfo(itemId, listId, listName, itemIndex);
    }
    saveItemMetaToStorage(itemId, card.getAttribute('data-item-category'), card.getAttribute('data-item-category2'), card.getAttribute('data-item-variant'));
  });

  // ADD TO CART (PDP) - Ürün detay sayfasından sepete eklendiğinde
  // product-form web component başarılı ekleme sonrası 'product-ajax:added' dispatch eder
  document.addEventListener('product-ajax:added', function (e) {
    var product = e.detail && e.detail.product;
    if (!product) return;

    // DOM'dan product-form wrapper'ını bul (metafield data attribute'ları burada)
    var productForm = document.querySelector('.product-form[data-item-handle]');

    // Ürün ID'si: DOM attribute öncelikli, yoksa API response'dan
    var itemId = (productForm && productForm.getAttribute('data-item-id'))
      || product.sku || String(product.product_id || '');

    // Per-product list bilgisini sessionStorage'dan oku
    var productList = getProductListInfo(itemId);

    // Fiyat: DOM attribute öncelikli (zaten bölünmüş), yoksa API response (kuruş cinsinden)
    var price = 0;
    var discount = 0;
    if (productForm) {
      price = parseFloat(productForm.getAttribute('data-item-price')) || 0;
      discount = parseFloat(productForm.getAttribute('data-item-discount')) || 0;
    } else {
      price = product.final_price ? product.final_price / 100 : (product.price ? product.price / 100 : 0);
      var compareAtPrice = product.compare_at_price ? product.compare_at_price / 100 : price;
      discount = compareAtPrice > price ? (compareAtPrice - price) : 0;
    }

    // Category/variant bilgileri: DOM'dan (metafield), yoksa API response'dan
    var itemCategory = (productForm && productForm.getAttribute('data-item-category')) || '';
    var itemCategory2 = (productForm && productForm.getAttribute('data-item-category2')) || '';
    var itemVariant = (productForm && productForm.getAttribute('data-item-variant')) || '';
    if (!itemVariant && product.variant_title && product.variant_title !== 'Default Title') {
      itemVariant = product.variant_title;
    }
    saveItemMetaToStorage(itemId, itemCategory, itemCategory2, itemVariant);

    var pdpAtcItem = {
      item_id: itemId,
      item_name: product.product_title || product.title || '',
      item_brand: product.vendor || '',
      item_category: itemCategory,
      item_category2: itemCategory2,
      item_variant: itemVariant,
      item_list_id: productList.listId,
      item_list_name: productList.listName,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: productList.index,
      quantity: product.quantity || 1
    };
    dlPush('add_to_cart', { currency: 'TRY', value: (price * (product.quantity || 1)).toFixed(2), items: [pdpAtcItem] });
    Shopify.analytics.publish('custom_add_to_cart', {
      item_list_id: productList.listId,
      item_list_name: productList.listName,
      item_id: pdpAtcItem.item_id,
      item_name: pdpAtcItem.item_name,
      item_brand: pdpAtcItem.item_brand,
      item_category: pdpAtcItem.item_category,
      item_category2: pdpAtcItem.item_category2,
      item_variant: pdpAtcItem.item_variant,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: productList.index,
      quantity: product.quantity || 1
    });
  });

  // REMOVE FROM CART - Ürün sepetten çıkarıldığında (cart-remove-item butonu ile)
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[is="cart-remove-item"]');
    if (!removeBtn) return;

    var priceValue = removeBtn.getAttribute('data-item-price');
    var discountValue = removeBtn.getAttribute('data-item-discount');
    var quantityValue = removeBtn.getAttribute('data-item-quantity');

    var price = priceValue ? parseFloat(priceValue) : 0;
    var discount = discountValue ? parseFloat(discountValue) : 0;
    var quantity = quantityValue ? parseInt(quantityValue, 10) : 1;

    // Per-product list bilgisini oku
    var itemId = removeBtn.getAttribute('data-item-id') || '';
    var productList = getProductListInfo(itemId);
    var listId = productList.listId;
    var listName = productList.listName;
    var itemIndex = productList.index;

    var rfcItem = {
      item_id: itemId,
      item_name: removeBtn.getAttribute('data-item-name') || '',
      item_brand: removeBtn.getAttribute('data-item-brand') || '',
      item_category: removeBtn.getAttribute('data-item-category') || '',
      item_category2: removeBtn.getAttribute('data-item-category2') || '',
      item_variant: removeBtn.getAttribute('data-item-variant') || '',
      item_list_id: listId,
      item_list_name: listName,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: itemIndex,
      quantity: quantity
    };
    dlPush('remove_from_cart', { currency: 'TRY', value: (price * quantity).toFixed(2), items: [rfcItem] });
    Shopify.analytics.publish('custom_remove_from_cart', {
      item_list_id: listId,
      item_list_name: listName,
      item_id: rfcItem.item_id,
      item_name: rfcItem.item_name,
      item_brand: rfcItem.item_brand,
      item_category: rfcItem.item_category,
      item_category2: rfcItem.item_category2,
      item_category3: removeBtn.getAttribute('data-item-category3') || '',
      item_variant: rfcItem.item_variant,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: itemIndex,
      quantity: quantity
    });
  });

  // ADD TO CART (Plus button) - Cart drawer'da plus butonuna tıklandığında
  document.addEventListener('click', function (e) {
    var plusButton = e.target.closest('button[name="plus"]');
    if (!plusButton) return;

    var quantityInput = plusButton.closest('quantity-input.cart-quantity');
    if (!quantityInput) return;

    var priceValue = quantityInput.getAttribute('data-item-price');
    var discountValue = quantityInput.getAttribute('data-item-discount');

    var price = priceValue ? parseFloat(priceValue) : 0;
    var discount = discountValue ? parseFloat(discountValue) : 0;

    // Per-product list bilgisini oku
    var itemId = quantityInput.getAttribute('data-item-id') || '';
    var productList = getProductListInfo(itemId);
    var listId = productList.listId;
    var listName = productList.listName;
    var itemIndex = productList.index;

    var plusAtcItem = {
      item_id: itemId,
      item_name: quantityInput.getAttribute('data-item-name') || '',
      item_brand: quantityInput.getAttribute('data-item-brand') || '',
      item_category: quantityInput.getAttribute('data-item-category') || '',
      item_category2: quantityInput.getAttribute('data-item-category2') || '',
      item_variant: quantityInput.getAttribute('data-item-variant') || '',
      item_list_id: listId,
      item_list_name: listName,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: itemIndex,
      quantity: 1
    };
    dlPush('add_to_cart', { currency: 'TRY', value: price.toFixed(2), items: [plusAtcItem] });
    Shopify.analytics.publish('custom_add_to_cart', {
      item_list_id: listId,
      item_list_name: listName,
      item_id: plusAtcItem.item_id,
      item_name: plusAtcItem.item_name,
      item_brand: plusAtcItem.item_brand,
      item_category: plusAtcItem.item_category,
      item_category2: plusAtcItem.item_category2,
      item_variant: plusAtcItem.item_variant,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: itemIndex,
      quantity: 1
    });
  });

  // REMOVE FROM CART (Minus button) - Cart drawer'da minus butonuna tıklandığında
  document.addEventListener('click', function (e) {
    var minusButton = e.target.closest('button[name="minus"]');
    if (!minusButton) return;

    var quantityInput = minusButton.closest('quantity-input.cart-quantity');
    if (!quantityInput) return;

    var priceValue = quantityInput.getAttribute('data-item-price');
    var discountValue = quantityInput.getAttribute('data-item-discount');

    var price = priceValue ? parseFloat(priceValue) : 0;
    var discount = discountValue ? parseFloat(discountValue) : 0;

    // Per-product list bilgisini oku
    var itemId = quantityInput.getAttribute('data-item-id') || '';
    var productList = getProductListInfo(itemId);
    var listId = productList.listId;
    var listName = productList.listName;
    var itemIndex = productList.index;

    var minusRfcItem = {
      item_id: itemId,
      item_name: quantityInput.getAttribute('data-item-name') || '',
      item_brand: quantityInput.getAttribute('data-item-brand') || '',
      item_category: quantityInput.getAttribute('data-item-category') || '',
      item_category2: quantityInput.getAttribute('data-item-category2') || '',
      item_variant: quantityInput.getAttribute('data-item-variant') || '',
      item_list_id: listId,
      item_list_name: listName,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: itemIndex,
      quantity: 1
    };
    dlPush('remove_from_cart', { currency: 'TRY', value: price.toFixed(2), items: [minusRfcItem] });
    Shopify.analytics.publish('custom_remove_from_cart', {
      item_list_id: listId,
      item_list_name: listName,
      item_id: minusRfcItem.item_id,
      item_name: minusRfcItem.item_name,
      item_brand: minusRfcItem.item_brand,
      item_category: minusRfcItem.item_category,
      item_category2: minusRfcItem.item_category2,
      item_category3: quantityInput.getAttribute('data-item-category3') || '',
      item_variant: minusRfcItem.item_variant,
      price: price.toFixed(2),
      discount: discount.toFixed(2),
      index: itemIndex,
      quantity: 1
    });
  });

  // VIEW CART - Cart sayfası yüklendiğinde
  function sendViewCartEvent() {
    var mainCart = document.querySelector('main-cart[data-cart-total]');
    if (!mainCart) return;

    var cartItems = mainCart.querySelectorAll('.cart-item[data-item-id]');
    if (cartItems.length === 0) return;

    var cartTotal = mainCart.getAttribute('data-cart-total') || '0';

    var items = [];
    cartItems.forEach(function(item, index) {
      var priceValue = item.getAttribute('data-item-price');
      var discountValue = item.getAttribute('data-item-discount');
      var quantityValue = item.getAttribute('data-item-quantity');

      var price = priceValue ? parseFloat(priceValue) : 0;
      var discount = discountValue ? parseFloat(discountValue) : 0;
      var quantity = quantityValue ? parseInt(quantityValue, 10) : 1;

      // Per-product list bilgisini oku
      var itemId = item.getAttribute('data-item-id') || '';
      var productList = getProductListInfo(itemId);
      saveItemMetaToStorage(itemId, item.getAttribute('data-item-category'), item.getAttribute('data-item-category2'), item.getAttribute('data-item-variant'));

      items.push({
        item_id: itemId,
        item_name: item.getAttribute('data-item-name') || '',
        item_brand: item.getAttribute('data-item-brand') || '',
        item_category: item.getAttribute('data-item-category') || '',
        item_category2: item.getAttribute('data-item-category2') || '',
        item_category3: item.getAttribute('data-item-category3') || '',
        item_variant: item.getAttribute('data-item-variant') || '',
        item_list_id: productList.listId,
        item_list_name: productList.listName,
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        quantity: quantity,
        index: productList.index || index
      });
    });

    if (items.length > 0) {
      dlPush('view_cart', { currency: 'TRY', value: parseFloat(cartTotal).toFixed(2), items: items });
      Shopify.analytics.publish('custom_view_cart', {
        value: parseFloat(cartTotal).toFixed(2),
        items: items
      });
    }
  }

  // VIEW CART (Cart Drawer) - Drawer açıldığında
  var _viewCartDrawerSent = false; // Tekrarlı tetiklemeyi önle

  function sendViewCartDrawerEvent() {
    if (_viewCartDrawerSent) return;

    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    // Cart drawer'daki ürün bilgilerini quantity-input elementlerinden al
    var quantityInputs = cartDrawer.querySelectorAll('quantity-input.cart-quantity[data-item-id]');
    if (quantityInputs.length === 0) return;

    _viewCartDrawerSent = true;

    var totalValue = 0;
    var items = [];

    quantityInputs.forEach(function(qi, index) {
      var priceValue = qi.getAttribute('data-item-price');
      var discountValue = qi.getAttribute('data-item-discount');

      var price = priceValue ? parseFloat(priceValue) : 0;
      var discount = discountValue ? parseFloat(discountValue) : 0;

      // Quantity değerini input'tan al
      var qtyInput = qi.querySelector('.quantity__input');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      totalValue += price * quantity;

      // Per-product list bilgisini oku
      var itemId = qi.getAttribute('data-item-id') || '';
      var productList = getProductListInfo(itemId);
      saveItemMetaToStorage(itemId, qi.getAttribute('data-item-category'), qi.getAttribute('data-item-category2'), qi.getAttribute('data-item-variant'));

      items.push({
        item_id: itemId,
        item_name: qi.getAttribute('data-item-name') || '',
        item_brand: qi.getAttribute('data-item-brand') || '',
        item_category: qi.getAttribute('data-item-category') || '',
        item_category2: qi.getAttribute('data-item-category2') || '',
        item_variant: qi.getAttribute('data-item-variant') || '',
        item_list_id: productList.listId,
        item_list_name: productList.listName,
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        quantity: quantity,
        index: productList.index || index
      });
    });

    if (items.length > 0) {
      dlPush('view_cart', { currency: 'TRY', value: totalValue.toFixed(2), items: items });
      Shopify.analytics.publish('custom_view_cart', {
        value: totalValue.toFixed(2),
        items: items
      });
    }
  }

  // Cart drawer açılma/kapanma takibi
  // Not: drawer:handleAfterShow/Hide event'leri overlay CSS transition'a bağlı,
  // transition tamamlanmazsa event'ler dispatch edilmiyor.
  // Bu yüzden MutationObserver ile 'open' attribute'unu izliyoruz.
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'open') {
          if (cartDrawerEl.hasAttribute('open')) {
            // Drawer açıldı — DOM güncellenmiş olabilir, kısa gecikme ile oku
            setTimeout(sendViewCartDrawerEvent, 150);
          } else {
            // Drawer kapandı — flag'i resetle (tekrar açılınca yeni event gönderilsin)
            _viewCartDrawerSent = false;
          }
        }
      });
    }).observe(cartDrawerEl, { attributes: true });
  }

  // Cart sayfasında view_cart event'ini tetikle
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sendViewCartEvent);
  } else {
    sendViewCartEvent();
  }

  // ADD TO CART BUNDLE - Products Bundle section'ında "Tümünü Sepete Ekle" butonu ile
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.products-bundle__button .btn--primary');
    if (!button) return;

    var bundleSection = button.closest('.products-bundle');
    if (!bundleSection) return;

    var productCards = bundleSection.querySelectorAll('[data-item-handle]');
    if (productCards.length === 0) return;

    var firstCard = productCards[0];

    // List bilgisini card'dan veya getListInfo'dan al
    var listId = firstCard.getAttribute('data-list-id') || '';
    var listName = firstCard.getAttribute('data-list-name') || '';

    if (!listId && !listName) {
      var list = getListInfo(firstCard);
      listId = list.id;
      listName = list.name;
    }

    var totalValue = 0;
    var items = [];

    productCards.forEach(function(card) {
      var priceValue = card.getAttribute('data-item-price');
      var discountValue = card.getAttribute('data-item-discount');

      var price = priceValue ? parseFloat(priceValue) : 0;
      var discount = discountValue ? parseFloat(discountValue) : 0;

      totalValue += price;
      saveItemMetaToStorage(card.getAttribute('data-item-id'), card.getAttribute('data-item-category'), card.getAttribute('data-item-category2'), card.getAttribute('data-item-variant'));

      items.push({
        item_id: card.getAttribute('data-item-id') || '',
        item_name: card.getAttribute('data-item-name') || '',
        item_brand: card.getAttribute('data-item-brand') || '',
        item_category: card.getAttribute('data-item-category') || '',
        item_category2: card.getAttribute('data-item-category2') || '',
        item_variant: card.getAttribute('data-item-variant') || '',
        item_list_id: listId,
        item_list_name: listName,
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        index: parseInt(card.getAttribute('data-item-index'), 10) || 0,
        quantity: 1
      });
    });

    if (items.length > 0) {
      dlPush('add_to_cart', { currency: 'TRY', value: totalValue.toFixed(2), items: items });
      Shopify.analytics.publish('custom_add_to_cart_bundle', {
        item_list_id: listId,
        item_list_name: listName,
        value: totalValue.toFixed(2),
        items: items
      });
    }
  });
})();

// ---- apply_filter dataLayer event (GTM / collection facets) ----
// Pushes to window.dataLayer only — never to Shopify.analytics.publish.
// GTM / Ingage will handle the GA4/Google Ads side once consent is live.
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var pendingLabel = null;

  function getLabelFromDetails(details) {
    try {
      var el = details.querySelector('summary .h6');
      if (!el) return '';
      var text = '';
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3) text += n.textContent;
      });
      return text.trim() || el.textContent.trim();
    } catch (e) {
      return '';
    }
  }

  function findLabelByParamKey(key) {
    try {
      var input = document.querySelector('[is="facet-form"] input[name="' + key + '"]');
      if (!input) return key;
      var details = input.closest('details[data-filter]');
      return details ? getLabelFromDetails(details) : key;
    } catch (e) {
      return key;
    }
  }

  // Checkbox / swatch / price-range filter change → store filter_name
  document.addEventListener('change', function (e) {
    try {
      var el = e.target;
      if (!el) return;

      // Regular filter inputs: name starts with "filter."
      if (el.name && el.name.indexOf('filter.') === 0) {
        var details = el.closest('details[data-filter]');
        if (details) pendingLabel = getLabelFromDetails(details);
        return;
      }

      // NumericRange text inputs have no name; they live inside <numeric-range>
      if (el.closest && el.closest('numeric-range')) {
        var details = el.closest('details[data-filter]');
        if (details) pendingLabel = getLabelFromDetails(details);
      }
    } catch (e) {}
  });

  // Filter-tag removal click (capture phase — read URL before FacetRemove changes it)
  // Must NOT call preventDefault or stopPropagation.
  document.addEventListener('click', function (e) {
    try {
      var anchor = e.target && e.target.closest ? e.target.closest('[is="facet-remove"]') : null;
      if (!anchor) return;

      // "Clear all" — skip; no single filter_name applies
      if (anchor.classList.contains('facet-clear-all')) {
        pendingLabel = null;
        return;
      }

      var removalParams = new URLSearchParams(new URL(anchor.href).search);
      var currentParams = new URLSearchParams(window.location.search);
      var changedKey = null;
      currentParams.forEach(function (value, key) {
        if (changedKey || key.indexOf('filter.') !== 0) return;
        if (removalParams.getAll(key).indexOf(value) === -1) changedKey = key;
      });

      pendingLabel = changedKey ? findLabelByParamKey(changedKey) : null;
    } catch (e) {}
  }, true);

  document.addEventListener('collection:rerendered', function () {
    try {
      if (!pendingLabel) return;
      var label = pendingLabel;
      pendingLabel = null;

      // Read active filter state from server-re-rendered facet form DOM
      var activeFilters = {};
      var form = document.querySelector('[is="facet-form"]');
      if (form) {
        form.querySelectorAll('details[data-filter]').forEach(function (details) {
          try {
            var lbl = getLabelFromDetails(details);
            if (!lbl) return;
            var vals = [];

            var priceMin = details.querySelector('input[name*="price.gte"]');
            var priceMax = details.querySelector('input[name*="price.lte"]');
            if (priceMin || priceMax) {
              var mn = priceMin ? priceMin.value : '';
              var mx = priceMax ? priceMax.value : '';
              if (mn || mx) vals.push(mn + '-' + mx);
            } else {
              var numVals = [];
              details.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
                if (!cb.checked) return;
                if (cb.closest('.numeric-range-values')) {
                  numVals.push(cb.value);
                } else {
                  vals.push(cb.value);
                }
              });
              if (numVals.length > 0) vals = numVals;
            }

            if (vals.length > 0) activeFilters[lbl] = vals;
          } catch (e) {}
        });
      }

      var activeFiltersStr = Object.keys(activeFilters)
        .map(function (k) { return k + ':' + activeFilters[k].join(','); })
        .join('|');

      var countEl = document.getElementById('ProductCount');
      var resultsCount = 0;
      if (countEl) {
        var m = countEl.textContent.match(/\d+/);
        if (m) resultsCount = parseInt(m[0], 10);
      }

      var listEl = document.getElementById('ProductsList');
      var itemListId = listEl ? (listEl.getAttribute('data-list-id') || '') : '';
      var itemListName = listEl ? (listEl.getAttribute('data-list-name') || '') : '';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'apply_filter',
        filter_name: label,
        filter_value: (activeFilters[label] || []).join(','),
        active_filters: activeFiltersStr,
        results_count: resultsCount,
        item_list_id: itemListId,
        item_list_name: itemListName
      });
    } catch (e) {}
  });
})();
